import React, { useMemo } from 'react';
import { sortMembersBySortOrderFirst } from '../../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';
import { Event } from './Event/Event';

interface EventsListProps {
  node: any;
  prefix: string;
}

export function EventsList({ prefix, node }: EventsListProps) {
  const events = useMemo(() => {
    return sortMembersBySortOrderFirst(node?.data?.events || []) || [];
  }, [node]);

  return (
    <>
      {events.map((event) => (
        <Event
          key={`__event_${event.urlFormat}`}
          event={event}
          prefix={prefix}
          node={node}
        />
      ))}
    </>
  );
}
